export default "__VITE_ASSET__BCDx9k1X__"